/* Ecrilo — documents d'information : sommaire et retour à la fiche produit.
 *
 * Tout ce que fait ce script est une amélioration : sans lui, la page reste
 * lisible de bout en bout et le bouton « Retour » ramène au kit configuré dans
 * la section. Il n'invente aucune ancre — il n'utilise que les titres présents
 * dans le texte publié depuis l'admin.
 */
(function () {
  "use strict";

  var doc = document;
  var racine = doc.querySelector("[data-ec-legal]");
  if (!racine) return;

  // Sur une page légale, le texte est dans notre article ; sur une politique de la
  // boutique, c'est Shopify qui l'enveloppe, et nous n'en contrôlons pas le balisage.
  var prose = racine.querySelector("[data-ec-legal-prose]") || racine.querySelector(".shopify-policy__body");
  var toc = racine.querySelector("[data-ec-legal-toc]");
  var liste = racine.querySelector("[data-ec-legal-toc-list]");
  var reduit = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ── Retour à la fiche d'où l'on vient ─────────────────────
     La landing mémorise son propre chemin en sessionStorage ; on le relit ici.
     Plus fiable que le référent, qui disparaît en navigation privée, dans
     certains navigateurs intégrés, et dès le deuxième clic interne. Le libellé
     ne change jamais : « Retour au kit Ecrilo », quelle que soit la variante. */
  var chemin = null;
  try { chemin = sessionStorage.getItem("ec_lp_retour"); } catch (e) {}
  if (!chemin) {
    try {
      var ref = doc.referrer ? new URL(doc.referrer) : null;
      if (ref && ref.host === window.location.host && /^\/products\//.test(ref.pathname)) chemin = ref.pathname + ref.search;
    } catch (e) {}
  }
  if (chemin && /^\/products\/[\w-]/.test(chemin)) {
    Array.prototype.forEach.call(racine.querySelectorAll("[data-ec-legal-back]"), function (a) { a.href = chemin; });
  }

  /* ── Identifiants de section ──────────────────────────────────
     Le texte vient de l'admin : il peut avoir été recollé sans identifiants.
     On complète ceux qui manquent, sans jamais écraser un identifiant existant
     (un lien externe pourrait pointer dessus). */
  function identifiant(texte, pris) {
    var base = texte.normalize("NFKD").replace(/[̀-ͯ]/g, "")
      .replace(/[^a-zA-Z0-9]+/g, "-").replace(/^-+|-+$/g, "").toLowerCase()
      .replace(/^[0-9]+-/, "") || "section";
    var essai = base, n = 2;
    while (pris[essai]) { essai = base + "-" + n; n += 1; }
    pris[essai] = true;
    return essai;
  }

  /* ── À partir d'ici, tout ne concerne que le sommaire ────── */
  var titres = prose ? Array.prototype.slice.call(prose.querySelectorAll("h2")) : [];
  if (!toc || !liste) return;
  if (titres.length < 6) {           // sous six sections, le document se parcourt à l'œil
    if (toc.parentNode) toc.parentNode.removeChild(toc);
    return;
  }

  var pris = {};
  Array.prototype.forEach.call(doc.querySelectorAll("[id]"), function (n) { pris[n.id] = true; });
  titres.forEach(function (h) {
    if (!h.id) h.id = identifiant(h.textContent || "", pris);
  });

  if (location.hash) {
    var vise = doc.getElementById(decodeURIComponent(location.hash.slice(1)));
    if (vise && prose.contains(vise)) {
      vise.setAttribute("tabindex", "-1");
      vise.scrollIntoView({ behavior: "auto", block: "start" });
      vise.focus({ preventScroll: true });
    }
  }

  /* ── Construction du sommaire ─────────────────────────────── */
  var liens = titres.map(function (h) {
    var li = doc.createElement("li");
    var a = doc.createElement("a");
    a.href = "#" + h.id;
    a.textContent = (h.textContent || "").trim();
    li.appendChild(a);
    liste.appendChild(li);
    return a;
  });

  toc.hidden = false;
  // Sur petit écran, le sommaire s'ouvre à la demande : le texte reste en premier.
  if (toc.tagName === "DETAILS") toc.open = window.matchMedia("(min-width: 1024px)").matches;

  /* ── Section en cours de lecture ───────────────────────────
     Le titre courant est celui du dernier repère franchi vers le haut de la
     fenêtre : plus stable qu'un simple « visible à l'écran » sur des sections
     longues et inégales. */
  var courant = null;
  function marquer(a) {
    if (courant === a) return;
    if (courant) courant.removeAttribute("aria-current");
    if (a) a.setAttribute("aria-current", "true");
    courant = a;
  }

  if ("IntersectionObserver" in window) {
    var vus = {};
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) { vus[e.target.id] = e.isIntersecting || e.boundingClientRect.top < 0; });
      var dernier = null;
      for (var i = 0; i < titres.length; i++) {
        if (titres[i].getBoundingClientRect().top - 90 <= 0) dernier = liens[i];
      }
      marquer(dernier || liens[0]);
    }, { rootMargin: "-88px 0px -70% 0px", threshold: [0, 1] });
    titres.forEach(function (h) { io.observe(h); });
  }

  /* ── Défilement vers une section ───────────────────────────
     Le focus suit le lien : au clavier, la lecture reprend au bon endroit. */
  liste.addEventListener("click", function (ev) {
    var a = ev.target.closest && ev.target.closest("a[href^='#']");
    if (!a) return;
    var cible = doc.getElementById(decodeURIComponent(a.getAttribute("href").slice(1)));
    if (!cible) return;
    ev.preventDefault();
    cible.scrollIntoView({ behavior: reduit ? "auto" : "smooth", block: "start" });
    if (!cible.hasAttribute("tabindex")) cible.setAttribute("tabindex", "-1");
    cible.focus({ preventScroll: true });
    if (history.replaceState) history.replaceState(null, "", "#" + cible.id);
    if (toc.tagName === "DETAILS" && window.innerWidth < 1024) toc.open = false;
  });

})();
